import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { LoadingScreen } from '../components/common/LoadingScreen';
import { ErrorScreen } from '../components/common/ErrorScreen';




export const NewsUpdatesPage = () => {
  const [newsArticles, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  // Function to handle clicking on a news article
  const handleClick = (id) => {
    navigate(`/news/${id}`);
  };

  const newsCollectionRef = collection(db, 'news');
  // Read News
  const fetchNews = async () => {
    try {
      const data = await getDocs(newsCollectionRef);
      setNews(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    } catch (err) {
      setError("Failed to fetch document: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  if (error) {
    return <ErrorScreen errorMessage={error} onRetry={fetchNews} />;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto p-4">
        <h1 className="text-4xl text-center font-bold mb-8 text-secondary">News and Updates</h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {newsArticles.map((news) => (
            <div
              key={news.id}
              className="bg-white shadow-lg rounded-lg overflow-hidden cursor-pointer hover:shadow-xl"
              onClick={() => handleClick(news.id)}
            >
              {/* Image */}
              <img
                src={news.imageUrl}
                alt={news.title}
                className="w-full h-48 object-cover"
              />

              {/* Content */}
              <div className="p-4">
                {/* Title */}
                <h2 className="text-xl font-bold text-primary">{news.title}</h2>
                {/* Date */}
                {/* <p className="text-sm text-gray-500 mb-2">{news.date}</p> */}
                {/* Description (first 50 words) */}
                <p className="text-gray-700 mb-4">{news.description.split(' ').slice(0, 50).join(' ')}...</p>

                {/* Share Button */}
                <button className="text-sm text-white bg-primary px-4 py-2 rounded-md">
                  Share
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
